<template>
    <div class="tooltipElement">
        <template v-if="loading">
            <Loading/>
        </template>
        <button
            class="publish_project_btn"
            :class="isPublished ? 'active' : ''"
            @click="publishProject"
        >
            <span v-if="isPublished">{{ $t('editorSceneElementOptionsPublished') }}</span>
            <span v-else>{{ $t('editorSceneElementOptionsPublish') }}</span>
        </button>
        <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsPublishProject') }`" />
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory';
    const ProjectRepository = RepositoryFactory.get('projects');
    import Loading from '@/components/Global/Loading.vue';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        data() {
            return {
                loading: false,
                isPublished: null
            }
        },
        components: {
            Loading,
            Tooltip
        },
        computed: {
            ...mapGetters([
                'getProject'
            ]),
            ...mapState([
                'sessionToken'
            ])
        },
        methods: {
            publishProject() {
                this.isPublished = !this.isPublished;
                this.loading = true;

                const headers = {
                    'api-key' : 'session',
                    'api-sign' : this.sessionToken.token
                }

                ProjectRepository.saveProject({ id: this.getProject.id, isPublished: this.isPublished }, headers)
                    .then(response => {
                        // console.log(response)
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        created() {
            this.isPublished = this.getProject.isPublished;
        }
    }
</script>

<style>
    .publish_project_btn {
        background-color: transparent;
        border: 1px solid #00A816;
        border-radius: 4px;
        cursor: pointer;
        display: inline-block;
        margin: 0;
        padding: 6px 15px;
        width: auto;
        color: #00A816;
        font-weight: 600;
        font-size: 13px;
        line-height: 17px;
        margin-right: 8px;
    }
    .publish_project_btn.active {
        background-color: #00A816;
        color: #ffffff;
    }
    .publish_project_btn:hover {
        opacity: 0.8;
    }
    @media (max-width: 1200px) {
        .publish_project_btn {
            padding: 6px 5px;
            font-size: 10px;
        }
    }
</style>